import React, { useEffect } from 'react';
import { ListModuleContentsData } from '@/api/seller/serv/oec_seller_learning_center_api';
import styles from '@/components/article-container/index.scss';
import BreadCrumb from '@/components/bread-crumb';
import { PagePathV2 } from '@/types/index';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { useHistory } from 'react-router-dom';
import {
  ModuleCard,
  ModuleCardType,
} from '@/containers/module-landing/module-card';
import { reportPageDuration, reportPageShow } from './index.Report';

export interface ConfigurationLandingPageProps {
  hotModuleData?: ListModuleContentsData;
  exploreData?: ListModuleContentsData;
}

export const ModuleLandingPage: React.FC<
  ConfigurationLandingPageProps
> = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { hotModuleData, exploreData } = props;
  const title = hotModuleData?.module_name;
  const hotModuleTitle = hotModuleData?.module_content_name;
  const exploreTitle = exploreData?.module_content_name;

  const hotModuleList = hotModuleData?.learning_info
    ?.filter(item => Number(item?.learning_id) !== 0)
    .slice(0, 4);
  const exploreList = exploreData?.learning_info?.filter(
    item => Number(item?.learning_id) !== 0,
  );

  const breadItemList = [
    {
      title: t('academy_search_result_catalog'),
      onClick: () => {
        history.push({
          pathname: PagePathV2.Home,
        });
      },
    },
    { title: title ?? '' },
  ];

  useEffect(() => {
    const startTime = Date.now();
    reportPageShow();

    const handlePageDuration = () => {
      reportPageDuration(Date.now() - startTime);
    };

    window.addEventListener('beforeunload', handlePageDuration);
    return () => {
      handlePageDuration();
      window.removeEventListener('beforeunload', handlePageDuration);
    };
  }, []);

  return (
    <section className="mx-auto w-[1280px] bg-neutral-white pt-32 px-24 pb-16 my-16 rounded-8">
      {title && (
        <>
          <BreadCrumb className={styles.breadCrumb} items={breadItemList} />
          <p className="text-h1-bold text-neutral-text1 mb-[39px]">{title}</p>
        </>
      )}
      <p className="text-h2-bold text-black-0 mb-24">{hotModuleTitle}</p>
      <div className="grid grid-cols-2 gap-24">
        {hotModuleList?.map((item, index) => {
          return (
            <ModuleCard
              info={item}
              key={index}
              type={ModuleCardType.HotModule}
            />
          );
        })}
      </div>
      <p className="text-h2-bold text-black-0 mt-40 mb-24">{exploreTitle}</p>
      <div className="grid grid-cols-4 gap-16">
        {exploreList?.map((item, index) => {
          return (
            <ModuleCard
              info={item}
              key={index}
              type={ModuleCardType.ExploreModule}
            />
          );
        })}
      </div>
    </section>
  );
};
